module.exports = __webpack_public_path__ + "img/predictive_banner.41d2f5e7.jpg";